import { FC } from "react";
import KickImage from 'Reuseables/KickImage';
import { Button } from "react-bootstrap";

import CustomBody from "../CustomBody/index";

//Assets
import Scooter from "../../../../images/scooter.png";
import Package from "../../../../images/package.png";
import ShipperIcon from "../../../../images/shipper.png";

//Interfaces
import { ComponentInterface } from "./definitions";

const Component: FC<ComponentInterface> = ({
  selected,
  loading,
  continueHandler,
  setPickup,
  setDropoff
}) => {
  return (
    <CustomBody loading={loading}>
      <div className="delivery-method-body">
        <p className="header">Delivery Method</p>
        <p className="description">
          Please select delivery method to sent your <span />
          package to Kick Avenue’s warehouse
        </p>

        <div onClick={setPickup} className={`method-wrapper pickup ${selected === "pickup" ? "selected" : ""}`}>
          <KickImage src={Scooter} alt="scooter" />
          <div className="content-wrapper" >
            <p className="title">Pick-up</p>
            <p className="information">Courier of your choosing will <span /> come to your location.</p>
            <p className="footer">Powered by <KickImage className="shipper-logo" src={ShipperIcon} alt="..." /></p>
          </div>
        </div>

        <div onClick={setDropoff} className={`method-wrapper dropoff ${selected === "dropoff" ? "selected" : ""}`}>
          <KickImage src={Package} alt="package" />
          <div className="content-wrapper" >
            <p className="title">Drop-off</p>
            <p className="information dropoff-info">Deliver it yourself or drop your package to any logistics service nearby.</p>
          </div>
        </div>

        <Button onClick={() => selected && continueHandler()} className={`continue ${!selected ? "disabled" : ""}`}><span>Continue</span></Button>
      </div>
    </CustomBody>
  )
}

export default Component;